<div class="card ivr-instance-list__card">
  <div class="card-body p-0">
    <app-base-list
      *ngIf="listConfig"
      [config]="listConfig"
      [data]="instances"
      [totalRecords]="instances.length"
      [loading]="loading"
      [paginator]="false"
      [rows]="1000" />
  </div>
</div>

<ng-template #nameTpl let-row>
  <div class="ivr-instance-list__name-cell">
    <span>{{ row.name }}</span>
    <span *ngIf="row.isDefault" class="ivr-instance-list__default-badge">
      <i class="pi pi-star-fill"></i>
      <span>{{ 'FreeswitchIntegration::Default' | abpLocalization }}</span>
    </span>
  </div>
</ng-template>

<ng-template #tenantsTpl let-row>
  <button
    *ngIf="row.assignedTenants?.length > 0"
    type="button"
    class="btn btn-link btn-sm ivr-instance-list__tenant-trigger"
    (click)="showTenantPopover(row, $event)">
    {{ row.assignedTenants.length }}
  </button>
  <span
    *ngIf="!row.assignedTenants || row.assignedTenants.length === 0"
    class="text-body-secondary">
    0
  </span>
</ng-template>

<ng-template #actionsTpl let-row>
  <app-action-menu [items]="getMenuItems(row)"></app-action-menu>
</ng-template>

<p-popover #tenantPopover styleClass="ivr-instance-list__popover">
  <ng-template #content>
    <div class="ivr-instance-list__popover-content" *ngIf="tenantPopoverInstance">
      <div class="ivr-instance-list__popover-title">
        {{ 'FreeswitchIntegration::AssignedTenants' | abpLocalization }}
      </div>
      <ul
        class="ivr-instance-list__popover-list"
        *ngIf="popoverTenantNames.length > 0; else noTenants">
        <li
          *ngFor="let tenantName of popoverTenantNames; trackBy: trackByIndex"
          class="ivr-instance-list__popover-item">
          {{ tenantName }}
        </li>
      </ul>
      <ng-template #noTenants>
        <div class="ivr-instance-list__popover-empty">
          {{ 'FreeswitchIntegration::NoTenantsAssigned' | abpLocalization }}
        </div>
      </ng-template>
    </div>
  </ng-template>
</p-popover>
